import { types, LanguagesActionsType, ILanguages } from '../types/languages'

export const initialState: ILanguages = {
  isLoading: false,
  list: [],
}

export const languages = (
  state = initialState,
  action: LanguagesActionsType
): ILanguages => {
  switch (action.type) {
    case types.GET_LANGUAGES__STARTED:
      return { ...state, isLoading: true }
    case types.GET_LANGUAGES__SUCCESS:
      return { isLoading: false, list: action.list }
    case types.GET_LANGUAGES__FAILURE:
    case types.GET_LANGUAGES__CANCEL:
      return { ...state, isLoading: false }
    default:
      return state
  }
}
